'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { Checked } from '@assets/icons';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { cn } from 'cn';
const Checkbox = t0 => {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("ease border-tertiary-300 bg-background hover:border-primary-500 hover:bg-primary-100/40 focus-visible:ring-primary data-[state=checked]:border-primary data-[state=checked]:bg-primary flex size-5 shrink-0 cursor-pointer items-center justify-center rounded-md border-[1.5px] p-0 shadow-sm transition-[border-color,background-color,box-shadow] duration-0 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:shadow-sm", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CheckboxPrimitive.Indicator className="flex items-center justify-center" data-sentry-element="CheckboxPrimitive.Indicator" data-sentry-source-file="checkbox.tsx"><Checked className="text-primary-foreground h-2.5" data-sentry-element="Checked" data-sentry-source-file="checkbox.tsx" /></CheckboxPrimitive.Indicator>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t1) {
    t3 = <CheckboxPrimitive.Root className={t1} {...props} data-sentry-element="CheckboxPrimitive.Root" data-sentry-component="Checkbox" data-sentry-source-file="checkbox.tsx">{t2}</CheckboxPrimitive.Root>;
    $[6] = props;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
Checkbox.displayName = CheckboxPrimitive.Root.displayName;
export { Checkbox };